<span *ngIf="localConfig" >
    <span *ngIf="localConfig.control === 'type-ahead-nominal'">
        <app-type-ahead-nominal-accounts [control]="control"
            [config]="localConfig"></app-type-ahead-nominal-accounts>
    </span>
    <span *ngIf="localConfig.control === 'checkbox'">
        <mat-checkbox [formControl]="control"></mat-checkbox>
        <!-- <mat-slide-toggle [formControl]="control"></mat-slide-toggle> -->
    </span>
    <div *ngIf="localConfig.control === 'listbox'" class="nat-form-field"
            style="overflow-y: scroll;">
        <mat-label>{{localConfig.label}}</mat-label>
        <mat-selection-list [formControl]="control" [multiple]="false">
            <mat-list-option *ngFor="let o of localConfig.dropdownList"  [value]="o.key">
                    {{o.value}}
            </mat-list-option>
        </mat-selection-list>
        <span matSuffix *ngIf="localConfig.tooltip">
            <app-field-tooltip-suffix [tooltip]="localConfig.tooltip" ></app-field-tooltip-suffix>
        </span>
        <mat-error>
            <span>{{localConfig.validation}}</span>
        </mat-error>
    </div>
    <app-input-edit-helper *ngIf="localConfig.control === 'input'" 
        [control]="control"
        [config]="localConfig"
        [errorState]="errorState"></app-input-edit-helper>
    <mat-form-field *ngIf="localConfig.control === 'textarea'" 
        class="mat-field-width">
        <textarea matInput 
                [formControl]="control"
                placeholder="{{localConfig.label}}"
                [errorStateMatcher]="errorState"
        ></textarea>
        <mat-error>
            <span>{{localConfig.validation}}</span>
        </mat-error>
    </mat-form-field>
    <mat-form-field *ngIf="localConfig.control === 'select'" 
            class="mat-field-width">
        <mat-select [formControl]="control"
            placeholder="{{localConfig.label}}"
            [errorStateMatcher]="errorState">
            <mat-option *ngFor="let o of localConfig.dropdownList" [value]="o.key">
                {{o.value}}
            </mat-option>
        </mat-select>
        <span matSuffix *ngIf="localConfig.tooltip">
            <app-field-tooltip-suffix [tooltip]="localConfig.tooltip" ></app-field-tooltip-suffix>
        </span>
        <mat-error>
            <span>{{localConfig.validation}}</span>
        </mat-error>
    </mat-form-field>
    @if(localConfig.control === 'datepicker'){
        <app-input-edit-date [config]="localConfig"
            [control]="control"
        ></app-input-edit-date>
    }
    <!-- <mat-form-field *ngIf="localConfig.control === 'datepicker'" 
            class="mat-field-width">
        <input matInput type="text"
                [matDatepicker]="datePicker"                
                placeholder="{{localConfig.label}}"
                [formControl]="control"
                [errorStateMatcher]="errorState"
                [min]="localConfig.minDate"
                [max]="localConfig.maxDate"
                 />
        <mat-datepicker-toggle matSuffix [for]="datePicker"></mat-datepicker-toggle>
        <mat-datepicker #datePicker></mat-datepicker>
        <span matSuffix *ngIf="localConfig.tooltip">
            <app-field-tooltip-suffix [tooltip]="localConfig.tooltip" ></app-field-tooltip-suffix>
        </span>
        
        <mat-error>
            <span>{{localConfig.validation}}</span>
        </mat-error>
    </mat-form-field> -->
    <mat-form-field *ngIf="localConfig.control == 'richtext'" class="mat-field-width">
        <textarea matInput 
                [formControl]="control"
                placeholder="{{localConfig.label}}"
                [errorStateMatcher]="errorState"
        ></textarea>
        <mat-error>
            <span>{{localConfig.validation}}</span>
        </mat-error>
    </mat-form-field>
    <app-input-edit-class *ngIf="localConfig.control === 'class'"
        [config]="localConfig"
        [control]="control"
        >
    </app-input-edit-class>
    <app-input-edit-location *ngIf="localConfig.control === 'location'"
        [config]="localConfig"
        [control]="control"
        >
    </app-input-edit-location>
</span>
